import React from 'react';
import { HomeSectionShell } from './HomeSectionShell';
import { WORKFLOW_COLUMNS, WORKFLOW_SECTION } from './homePageConstants';

export const ClimateActionWorkflowSection: React.FC = () => (
  <HomeSectionShell
    id="climate-action-workflow"
    title={WORKFLOW_SECTION.title}
    subtitle={WORKFLOW_SECTION.subtitle}
  >
    <div className="home-card-grid home-card-grid--three">
      {WORKFLOW_COLUMNS.map((column) => (
        <article key={column.title} className="home-workflow-card">
          <h3 className="home-workflow-card__title">{column.title}</h3>
          <ul className="home-workflow-card__list">
            {column.items.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </article>
      ))}
    </div>
  </HomeSectionShell>
);
